import { isValidInviteCodeFormat, normalizeInviteCode } from "@fortress/shared";

/** Browser path for a match. The URL speaks `gameId` — the match's one
 * stable identifier, which since codes became the gameId is also the lobby's
 * share code — never a Colyseus roomId: rooms die and revive (server
 * restarts, empty-room disposes) but the match link keeps working, resolved
 * to whatever live room hosts it via `POST /games/:gameId/room`. */
export function matchPath(gameId: string, spectate = false): string {
  const base = `/match/${encodeURIComponent(gameId)}`;
  return spectate ? `${base}?spectate=1` : base;
}

/** Parse `/match/:gameId` (+ optional `?spectate=1`) from the current location. */
export function parseMatchLocation(
  pathname: string = window.location.pathname,
  search: string = window.location.search,
): { gameId: string; spectate: boolean } | null {
  const m = pathname.match(/^\/match\/([^/]+)\/?$/);
  if (!m?.[1]) return null;
  let gameId: string;
  try {
    gameId = decodeURIComponent(m[1]);
  } catch {
    return null;
  }
  if (!gameId) return null;
  // The slug of every match minted since invite codes became the gameId IS
  // its share code — accept a hand-typed lowercase one.
  const asCode = normalizeInviteCode(gameId);
  if (isValidInviteCodeFormat(asCode)) gameId = asCode;
  const spectate = new URLSearchParams(search).get("spectate") === "1";
  return { gameId, spectate };
}
